import { render, staticRenderFns } from "./PharmacistProfile.vue?vue&type=template&id=adbe3c7e&scoped=true&"
import script from "./PharmacistProfile.vue?vue&type=script&lang=ts&"
export * from "./PharmacistProfile.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistProfile.vue?vue&type=style&index=0&id=adbe3c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbe3c7e",
  null
  
)

export default component.exports